// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutDefault_wrapper__k9ybc","main":"LayoutDefault_main__sS2tj","footer":"LayoutDefault_footer__8wAFV"};